'use strict';

/**
 * Used to dispatch custom events.
 *
 * @param {string} eventName - custom event name
 * @param {Object} eventData - custom event name
 */
function dispatch(eventName, eventData) {
    document.dispatchEvent(new CustomEvent(eventName, eventData));
}

module.exports = {
    dispatch: dispatch
};
